import { Component, EventEmitter, Input, Output } from "@angular/core";

import { CloseButtonComponent } from "@hermes/aphrodite-close-button";
import { SvgIconComponent } from "@hermes/aphrodite-svg";

import { type TrayData } from "../../models/tray-data.model";

@Component({
    selector: "h-tray-title",
    imports: [SvgIconComponent, CloseButtonComponent],
    templateUrl: "./tray-title.component.html",
    styleUrls: ["./tray-title.component.scss"],
})
export class TrayTitleComponent {
    /**
     * Tray displayed title.
     */
    @Input()
    public tray!: TrayData;

    @Output()
    public closeTray: EventEmitter<Event> = new EventEmitter<Event>();
}
